// Operator color definitions
export const operatorColors = {
    Soma: '#28a745',
    'Subtração': '#dc3545',
    'Multiplicação': '#6f42c1',
    'Divisão': '#fd7e14',
    'Potenciação': '#e83e8c',
    'Radiciação': '#17a2b8',
    'Igual a': '#A020F0',
    'Diferente de': '#FD7E14',
    'Diferente': '#FD7E14',
    'Maior que': '#007bff',
    'Menor que': '#6c757d',
    'Maior ou igual': '#20c997',
    'Maior ou igual a': '#20c997',
    'Menor ou igual': '#ffc107',
    'Menor ou igual a': '#ffc107',
    'Conjunção/Interseção': '#007bff',
    'Disjunção inclusiva/União': '#20c997',
    'Negação/complementação': '#6c757d',
    'Disjunção exclusiva': '#A020F0',
    Atribuir: '#ff9800'
};
